import { ConnectionType, Network } from '@capacitor/network';

export interface INetworkService {
    networkConnected: boolean | undefined;
    networkType: ConnectionType;
    stopNetworkStatusListener: () => void;
    startNetworkStatusListener: () => void;
    setCallback: (callback: ((connected: boolean)=> void), init?: boolean) => number;
    clearCallback: (callBackIndex: number) => void;
}

class NetworkService implements INetworkService {
    networkConnected: boolean | undefined;
    networkType: ConnectionType;
    isListening: boolean;
    private NetworkNotificationCallback: {[key in number]: (connected: boolean)=> void};
    private callbackKeys: number[];

    constructor() {
        this.NetworkNotificationCallback = {};
        this.callbackKeys = [];
        this.networkConnected = undefined;
        this.networkType = 'none';
        this.isListening = false;
        Network.getStatus().then(status => {
            console.log('Network status acquired', status);
            this.networkConnected = status.connected;
            this.networkType = status.connectionType;
            // Run any callbacks that were added before initialized
            this.runCallbacks(status.connected);
        })
        console.log('Network status test');
        this.startNetworkStatusListener();
    }

    setCallback = (callback: ((connected: boolean) => void), init?: boolean) => {
        // set the call back function to be called on all network changes
        const key = Date.now();
        this.NetworkNotificationCallback[key] = callback;
        this.callbackKeys.push(key);
        console.log('newNetworkSub', this.callbackKeys, callback);

        // Ensure that the callback is run immediately after it is set here and has an accurate value passed to in when it is run the first time.
        // If networkConnected is undefined the callback will be run immediately after the initial status is loaded.
        console.log('Why-Set', this.networkConnected);
        if (init && this.networkConnected !== undefined) {
            callback(this.networkConnected);
        }
        return key;
    }

    clearCallback = (callbackKey: number) => {
        if(callbackKey) {
            console.log('clearNetworkSub', callbackKey, this.NetworkNotificationCallback[callbackKey]);
            
            delete this.NetworkNotificationCallback[callbackKey];
            this.callbackKeys = this.callbackKeys.filter(key => key !== callbackKey);

            console.log('clearNetworkSub2', this.NetworkNotificationCallback);
        }
    }

    startNetworkStatusListener = () => {
        this.isListening = true;
        Network.addListener('networkStatusChange', status => {
            console.log('Network status changed', status);
            this.networkConnected = status.connected;
            this.networkType = status.connectionType;
            // run all callbacks on every change
            this.runCallbacks(status.connected);
        });
    }

    runCallbacks = (connected: boolean) => {
        // If callback properties are set call the functions
        if(this.callbackKeys.length) {
            this.callbackKeys.forEach(key => {
                if(this.NetworkNotificationCallback.hasOwnProperty(key)){
                    this.NetworkNotificationCallback[key](connected);
                }
            });
                
        }
    }

    stopNetworkStatusListener = () => {
        this.isListening = false;
        Network.removeAllListeners();
    }
}

export default NetworkService;